import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import axiosInstance from "../../../variables/api/axiosInstance";

const AddTypeEtablissement = ({
  show,
  handleClose,
  editMode,
  selectedType,
  types,
  onActionComplete,
}) => {
  const [libelle, setLibelle] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editMode && selectedType) {
      setLibelle(selectedType.libelleParametre || "");
    } else {
      setLibelle("");
    }
  }, [editMode, selectedType]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedLibelle = libelle.trim();

    if (!trimmedLibelle) {
      toast.warning("Le libellé est obligatoire.");
      return;
    }

    const isDuplicate = types?.some(
      (t) =>
        t.libelleParametre.toLowerCase() === trimmedLibelle.toLowerCase() &&
        (!editMode || t.parametreId !== selectedType?.parametreId)
    );
    if (isDuplicate) {
      toast.error("Ce type d'établissement existe déjà.");
      return;
    }

    setLoading(true);

    const payload = {
      ...selectedType,
      libelleParametre: trimmedLibelle,
      typeParametre: "TYPE_ETABLISSEMENT",
    };

    const request = editMode
      ? axiosInstance.put(`/api/parametre`, payload)
      : axiosInstance.post(`/api/parametre`, payload);

    request
      .then((res) => {
        toast.success(
          editMode
            ? "Type d'établissement modifié avec succès"
            : "Type d'établissement ajouté avec succès"
        );
        if (onActionComplete) onActionComplete(res.data);
        handleClose();
      })
      .catch((err) => {
        console.error("Erreur lors de l'enregistrement du type d'établissement :", err);
        toast.error("Impossible d'enregistrer le type d'établissement.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Body>
        <button
          type="button"
          className="btn-close btn-primary"
          onClick={handleClose}
          aria-label="Close"
        ></button>
        <div className="text-center mb-4">
          <h4>{editMode ? "Modifier le type d'établissement" : "Ajouter un type d'établissement"}</h4>
          <p>Renseignez le libellé et la valeur (optionnelle)</p>
        </div>
        <form className="row g-3" onSubmit={handleSubmit}>
          <div className="col-12">
            <label className="form-label" htmlFor="typeEtabLibelle">
              Libellé
            </label>
            <input
              id="typeEtabLibelle"
              type="text"
              className="form-control"
              value={libelle}
              onChange={(e) => setLibelle(e.target.value)}
              placeholder="Ex: CLINIQUE"
              required
            />
          </div>
          <div className="col-12 text-center">
            <button type="submit" className="btn btn-primary me-3" disabled={loading}>
              {loading ? "Enregistrement..." : "Enregistrer"}
            </button>
            <button type="button" className="btn btn-secondary" onClick={handleClose} disabled={loading}>
              Annuler
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddTypeEtablissement;
